import {
  AfterContentInit,
  ChangeDetectorRef,
  Component, effect,
  inject, input,
  model,
  OnDestroy,
  OnInit, signal,
  ViewChild
} from '@angular/core';
import {APIService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {ButtonComponent, ButtonOptions, ModalComponent, ModalOptions, TableComponent} from '@shared/components';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {SurgicalProcedure} from '@core/classes/tables/surgical-procedure';

@Component({
  selector: 'ncp-surgical-procedure-status-action',
  imports: [
    ButtonComponent,
    ModalComponent
  ],
  templateUrl: './surgical-procedure-status-action.component.html',
  styleUrl: './surgical-procedure-status-action.component.scss',
})
export class SurgicalProcedureStatusActionComponent implements OnInit, AfterContentInit, OnDestroy {
  protected readonly toastService = inject(ToastService);
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('btn') public btn!: ButtonComponent;

  protected data = model<SurgicalProcedure>();
  protected allData = model<SurgicalProcedure[]>();
  protected reloadData = model<() => {}>();
  protected index = input<number>();
  protected tbl = model<TableComponent<SurgicalProcedure>>(new TableComponent());

  protected btnOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'action'
    })
  );
  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.confirm,
    })
  );

  statusEffect = effect(() => {
    this.setConfirm();
  });

  setConfirm = () => {
    if(this.row?.version_id?.toString() !== this.patientService.version!.new?.toString()) {
      this.modOptions().title = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().message = this.row?.status === 1 ? 'confirm_disable' : 'confirm_enable';
      this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
      this.btnOptions().class = '';
      this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().onYes = this.changeStatus;
    } else {
      this.modOptions().title = 'delete_entry';
      this.modOptions().message = 'confirm_delete';
      this.btnOptions().icon = 'bi bi-trash3';
      this.btnOptions().class = 'btn-danger';
      this.btnOptions().tooltip = 'delete_entry';
      this.modOptions().onYes = this.deleteEntry;
    }
  }

  ngOnInit() {
    this.btnOptions().onClick = () => {
      this.setConfirm();
      this.btn.blur();
      this.mod.open();
    };
  }

  ngOnDestroy() {
    this.statusEffect.destroy();
  }

  ngAfterContentInit() {

  }

  get row() {
    return this.data();
  }
  set row(row) {
    this.data.set(row);
  }

  protected changeStatus = () => {
    this.apiService.call({
      path: '/surgical-procedures',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        status: this.data()?.status,
        coding_id: this.data()?.coding_id,
        procedure_date: this.data()?.procedure_date,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if(res && res.status && res.status.toString() === '1') {
        let allData = this.allData() as SurgicalProcedure[];
        allData[this.index()!].status = allData[this.index()!].status === 1 ? 0 : 1;
        this.row = allData[this.index()!];

        this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
        this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';

        (this.tbl() as TableComponent<SurgicalProcedure>).detectChanges();

        this.mod.close('success');
      }
    });
  }

  protected deleteEntry = () => {
    this.apiService.call({
      path: '/delete-surgical-procedures',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        coding_id: this.data()?.coding_id,
        procedure_date: this.data()?.procedure_date,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if (res && res.status && res.status.toString() === '1') {
        let allData = (this.tbl() as TableComponent<SurgicalProcedure>).tableData;

        (this.tbl() as TableComponent<SurgicalProcedure>).tableData = allData!.filter(item => {
          return !((item.coding_id?.toString() === this.data()?.coding_id?.toString()) &&
            (item.procedure_date?.toString() === this.data()?.procedure_date?.toString()) &&
            (item.version_id?.toString() === this.data()?.version_id?.toString()))
        });

        (this.tbl() as TableComponent<SurgicalProcedure>).reload().detectChanges();
        this.mod.close('success');
      }
    });
  }
}
